<template>
  <el-dropdown class="kq-theme-user" size="small">
    <div class="flex-row-center-v kq-theme-user-info">
      <div class="flex-column flex-align-end">
        <span class="text-main">{{ info ? `${info.name || '孔雀'}` : '未登录' }}</span>
        <span v-if="info" class="text-light text-sm">{{ info.companyName || '' }}</span>
      </div>
      <div class="flex-row-center kq-theme-user-logo margin-l-sm">
        <img src="@/assets/image/icon-logo.png" />
      </div>
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-if="isModifyPassword"
        style="height: 40px;line-height: 40px"
        @click.native="passwordVisible = true"
      >
        <kq-icon name="unlock-alt" style="width: 14px;" />
        修改密码
      </el-dropdown-item>
      <el-dropdown-item v-if="isModifyPhone" style="height: 40px;line-height: 40px" @click.native="phoneVisible = true">
        <kq-icon name="edit" style="width: 14px;" />
        修改手机
      </el-dropdown-item>
      <el-dropdown-item style="height: 40px;line-height: 40px" @click.native="logout">
        <kq-icon name="power-off" style="width: 14px;" />
        退出登录
      </el-dropdown-item>
    </el-dropdown-menu>

    <!-- 修改密码对话框 -->
    <modify-password :visible.sync="passwordVisible" />
    <!-- 修改手机号码对话框 -->
    <modify-phone :visible.sync="phoneVisible" />
  </el-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import ModifyPassword from './ModifyPassword'
import ModifyPhone from './ModifyPhone'
import setting from '@/setting'

export default {
  name: 'UserInfo',
  components: {
    ModifyPassword,
    ModifyPhone
  },
  data() {
    return {
      passwordVisible: false,
      phoneVisible: false
    }
  },
  computed: {
    ...mapState('user', ['permission', 'info']),

    isModifyPassword() {
      return (this.permission || []).includes('/manage/security/password') || !setting.isAuthorize
    },

    isModifyPhone() {
      return (this.permission || []).includes('/manage/security/phone') || !setting.isAuthorize
    }
  },
  methods: {
    /**
     * 退出登录
     */
    logout() {
      this.$confirm('确定要退出当前用户吗', '操作确认', { type: 'warning' })
        .then(() => this.$store.dispatch('account/logout'))
        .catch(() => null)
    }
  }
}
</script>
